import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

var getCookie = function getCookie(key) {
  return document.cookie.split('; ').reduce(function (total, currentCookie) {
    var _currentCookie$split = currentCookie.split('='),
        _currentCookie$split2 = _slicedToArray(_currentCookie$split, 2),
        storedKey = _currentCookie$split2[0],
        storedValue = _currentCookie$split2[1];

    return key === storedKey ? decodeURIComponent(storedValue) : total;
  }, '');
};

export default getCookie;